import React from 'react';
import { fireMessageEvent } from '../../messenger/utils';
import { useSelector, useDispatch } from 'react-redux';

import Close from '../chrome/Close';
import { setHeatStreakPanelToClosed } from '../../ui/actions';
import { setIncompletePicksModalToOpen, setPendingNavigation } from '../../picks/actions';

const CloseApp = () => {
  const dispatch = useDispatch();
  const { config, strings, ui, picks } = useSelector((state) => state);
  const { platform, env } = config;
  const { heatStreakPanelOpen } = ui;
  const { picked, picksSubmitted, picksLocked } = picks;
  const ariaLabel = strings['roles/button/close/aria'];

  const slotsPicked = Object.keys(picked)
    .map((id) => picked[id])
    .filter((id) => id);
  const hasUnsubmittedPicks = slotsPicked.length > 0 && !picksSubmitted && !picksLocked;

  const handleClose = (e) => {
    if (hasUnsubmittedPicks) {
      dispatch(setPendingNavigation('close'));
      dispatch(setIncompletePicksModalToOpen());
    } else if (heatStreakPanelOpen) {
      dispatch(setHeatStreakPanelToClosed());
      e.preventDefault();
    } else {
      fireMessageEvent({ type: 'CLOSE_WINDOW', platform, env });
    }
  };

  return <Close aria-label={ariaLabel} onClick={handleClose} />;
};

export default CloseApp;
